import React from 'react';
import { DatePickerButton } from './DatePickerButton';

export interface DateValuesSectionProps {
  selectedValues: string[];
  onValueChange: (value: string) => void;
  validationErrors?: string[];
  /** Is After: an empty picker opens on the current minute, not 00:00. */
  seedWithCurrentTime?: boolean;
}

/**
 * DateValuesSection - Date picker for date-based filters
 * Used for DATE column types with single-value operators (Is After / Is Before)
 * Values are stored as UTC ISO instants (legacy zone-less values read as UTC,
 * as the backend applies them); the picker edits them in the user's display
 * time zone.
 */
export const DateValuesSection: React.FC<DateValuesSectionProps> = ({
  selectedValues,
  onValueChange,
  validationErrors = [],
  seedWithCurrentTime,
}) => {
  const errorMessage = validationErrors.find(Boolean);

  // The picker's Apply stages the value into the draft; the filter itself is
  // committed solely via the filter's own Apply button.
  return (
    <div className="flex flex-col gap-2 p-4">
      <DatePickerButton
        value={selectedValues[0] ?? ''}
        onApply={onValueChange}
        placeholder="Select date"
        seedWithCurrentTime={seedWithCurrentTime}
      />
      {errorMessage && (
        <div className="text-xs text-destructive">{errorMessage}</div>
      )}
    </div>
  );
};
